import script from "./BaseFileUpload.vue?vue&type=script&lang=js"
export * from "./BaseFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/Components/primevue/BaseFileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a92857b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a92857b', __exports__)) {
    api.reload('7a92857b', __exports__)
  }
  
}


export default __exports__